import * as React from 'react';

interface ReviewSectionProps {
    title: string;
    children: React.ReactNode;
    className?: string;
}

export const ReviewSection: React.FC<ReviewSectionProps> = ({ title, children, className = "" }) => {
    return (
        <div className={`group ${className}`}>
            <div className="title">{title}</div>
            <div className="content">
                {children}
            </div>
        </div>
    );
};
